import React, { useEffect, useState } from 'react'
import { Loader } from '../../components'
import { useLocation, useNavigate } from 'react-router-dom'
import SignIn from '../../components/SignIn'

const Callback = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [code, setCode] = useState('')

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const code = searchParams.get('code')

    if (code) {
      setCode(code)
      return
    }

    console.warn('No code found')
    navigate('/logout')
  }, [location.search, navigate])

  return (
    <>
      {code && <SignIn oauthCode={code} />}
      <Loader />
    </>
  )
}

export default Callback
